import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogFilterComponent } from './dialog-filter.component';
import { SharedModules } from 'src/app/shared.modules';

@NgModule({
    declarations: [DialogFilterComponent],
    imports: [
        CommonModule,
        SharedModules
    ]
})
export class DialogFilterModule { }
